/****************************************************
 * Module Name:  eyecleanProxy.js
 * Project:      Pansuriya Impex Sales & Manufacturing
 * Owner:        info@pansuriyaimpex.com
 *
 * Copyright (c) Pansuriya Impex
 * All rights reserved.
 ****************************************************/
import restAPICall from "../../api/restAPICall";
import Constants from "../../constants";

export default class EyecleanProxy {
  static GetAllEyeclean = (callback) => {
    restAPICall(
      Constants.MANAGER_URL + "/eyeclean",
      "get",
      Constants.userToken,
      undefined,
      undefined,
      undefined,
      0
    )
      .then((response) => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  };

  static GetSingleEyeclean = (eyecleanId, callback) => {
    let params = {
      id: eyecleanId,
    };

    restAPICall(
      Constants.MANAGER_URL + "/eyeclean",
      "get",
      Constants.userToken,
      params,
      undefined,
      undefined,
      0
    )
      .then((response) => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  };

  static CheckEyecleanAvailable = (eyeclean, callback) => {
    let params = {
      eyeclean: eyeclean,
    };

    restAPICall(
      Constants.MANAGER_URL + "/eyeclean/available",
      "get",
      Constants.userToken,
      params,
      undefined,
      undefined,
      0
    )
      .then((response) => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  };

  static AddEyeclean = (eyeclean, callback) => {
    restAPICall(
      Constants.MANAGER_URL + "/eyeclean",
      "post",
      Constants.userToken,
      undefined,
      JSON.stringify(eyeclean),
      "application/json",
      0
    )
      .then((response) => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  };

  static UpdateEyeclean = (eyeclean, callback) => {
    restAPICall(
      Constants.MANAGER_URL + "/eyeclean",
      "put",
      Constants.userToken,
      undefined,
      JSON.stringify(eyeclean),
      "application/json",
      0
    )
      .then((response) => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  };

  static DeleteEyeclean = (eyeclean, callback) => {
    restAPICall(
      Constants.MANAGER_URL + "/eyeclean",
      "delete",
      Constants.userToken,
      undefined,
      JSON.stringify(eyeclean),
      "application/json",
      0
    )
      .then((response) => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  };
}
